module.exports = __webpack_public_path__ + "assets/img/ja-8ba7159b.png";